module.exports = __webpack_public_path__ + "img/s5CardBottomLogo2.7fbd3da4.svg";